export default {
  Button: {
    background: '#D0F6DE',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '12px!important',
    lineHeight: '14px!important',
    fontFamily: 'SF UI Display, sans-serif',
    fontStyle: 'normal!important',
    fontWeight: '500!important',
    textTransform: 'uppercase',
    color: '#14D15B',
    ':hover': {
      backgroundColor: '#D0F6DE'
    },
    '@media (minWidth: 800px)': {
      padding: '6px 12px',
      fontSize: '10px!important',
      lineHeight: '11px!important'
    }
  },
  yellowButton: {
    background: '#FFF6DC',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '12px!important',
    lineHeight: '14px!important',
    fontFamily: 'SF UI Display, sans-serif',
    fontStyle: 'normal!important',
    fontWeight: '500!important',
    textTransform: 'uppercase',
    marginRight: '8px',
    color: '#FFD051',
    ':hover': {
      backgroundColor: '#FFF6DC'
    },
    '@media (minWidth: 800px)': {
      padding: '6px 10px',
      fontSize: '10px!important',
      lineHeight: '13px!important'
    }
  },
  redButton: {
    background: '#FFE6E6',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '12px!important',
    lineHeight: '14px!important',
    fontFamily: 'SF UI Display, sans-serif',
    fontStyle: 'normal!important',
    fontWeight: '500!important',
    textTransform: 'uppercase',
    color: '#FF0400',
    ':hover': {
      backgroundColor: '#FFE6E6'
    },
    '@media (minWidth: 800px)': {
      padding: '6px 10px',
      fontSize: '10px!important',
      lineHeight: '13px!important'
    }
  }
};
